export default {
    name: 'reactElementInjector',
    process(value, key, options, translator) {
        const delim = /(<.+?>)/;
        const tokenizedString = value.split(delim);

        if (tokenizedString.length === 1) {
            /* nothing to replace */
            return value;
        }

        return tokenizedString
            .filter(Boolean) // don't care about empty strings
            .map((token) => {
                // replace <token> with `options[token]` or the empty string
                return delim.test(token)
                    ? options[token.replace(/<(.+)>/, '$1')] || ''
                    : token;
            });
    },
    type: 'postProcessor',
};
